/**
 * Shared canvas constants. FEET_TO_PX is the single source of truth for
 * the feet-to-pixel scale used by every shape component and the room
 * background — defining it once here (rather than duplicating the literal
 * `12` across five shape files) means a future zoom/scale feature is a
 * one-file change, not a five-file find-and-replace.
 */

export const FEET_TO_PX = 12;
